import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "5f847762-3764-49f2-8baf-2edf1966f852",
  publicId: "18",
  name: "FIR convolution",
  difficulty: 3,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, principle03, principle04, task01],
};

export default lesson;
